<template>
  <div class="card shadow-bg">
    <div class="border-0 card-header">
      <h3 class="mb-0">Example Links</h3>
    </div>
    <ul>
      <li v-for="example in examples" :key="example">
        <span
          class="btn-link example-link"
          :href="example + `?tag=${tag}`"
          @click.prevent="copyToClipboard(example + `?tag=${tag}`)"
          >{{ example + `?tag=${tag}` }}</span
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AffiliateExamples',
  props: {
    tag: String
  },
  data() {
    return {
      examples: [
        'https://www.chinesepod.com/',
        'https://www.chinesepod.com/lesson/88-characters-with-carly-part-1',
        'https://www.chinesepod.com/start-learning-chinese',
        'https://www.chinesepod.com/dictionary/学习'
      ]
    }
  },
  methods: {
    copyToClipboard(example) {
      this.$copyText(example).then(
        () => {
          this.$notify({
            type: 'success',
            message: `Copied to clipboard`
          })
        },
        () => {
          this.$notify({
            type: 'danger',
            message: `Failed to save to clipboard`
          })
        }
      )
    }
  }
}
</script>

<style scoped>
.example-link {
  cursor: pointer;
}
</style>
